import React from "react";
import styles from './EvaluationSummaryCard.module.scss';
import {ReactComponent as CheckIcon} from './Check.svg';
import {ReactComponent as ChevronIcon} from './Chevron.svg';
import Tag from "../tag/Tag";
import ScoreBar from "../scoreBar/ScoreBar";
import PropTypes from "prop-types";

const EvaluationSummaryCard = ({
  isOpened = false,
  onClick,
  data,
}) => {
  return (
    <div className={styles.card} onClick={onClick}>
      <div className={`${styles.arrow} ${isOpened ? styles.rotate : ''}`}>
        <ChevronIcon />
      </div>
      <div className={styles.check}>
        {data?.answer?.point && data?.answer?.point !== 0 ? <CheckIcon /> : 'NA'}
      </div>
      <div className={styles.question}>
        <h3>{data?.question?.type}</h3>
        {isOpened && <p>{data?.question?.question}</p>}
        <div className={styles.tags}>
          {data?.question?.tags.map((tag, index) => (
            <Tag
              key={tag}
              text={tag}
              variant={index + 1}
            />
          ))}
        </div>
        {isOpened && <hr />}
        <div className={styles.score}>
          <div className={styles.scoreBar}>
            {isOpened && <div className={styles.labels}>
              <span>Score</span>
              <span className={styles.right}>{data?.answer?.name}</span>
            </div>}
            <ScoreBar score={data?.answer?.point ?? 0} />
          </div>
        </div>
        {isOpened && data.comment && <div className={styles.commentBox}>
          <h4>Comment</h4>
          <p>{data.comment}</p>
        </div>}
      </div>
    </div>
  );
};

EvaluationSummaryCard.propTypes = {
  isOpened: PropTypes.bool,
  onClick: PropTypes.func.isRequired,
  data: PropTypes.shape({
    answer: PropTypes.shape({
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      point: PropTypes.number.isRequired,
      percentage: PropTypes.number
    }).isRequired,
    question: PropTypes.shape({
      type: PropTypes.string.isRequired,
      question: PropTypes.string.isRequired,
      tags: PropTypes.arrayOf(PropTypes.string).isRequired
    }).isRequired,
    comment: PropTypes.string
  }),
}

export default EvaluationSummaryCard;